
import React, { useState, useEffect } from 'react';
import style from './style.module.css';
import conditional from '../../utils/conditional';
import useSmoothState from '../../utils/useSmoothState';
import api from '../../api';
import publisher from '../../utils/publisher';

const PermissionModal = props => {

    const [visible, setVisible] = useState(false);
    const [notifications, setNotifications] = useSmoothState([], 0.5);
    const [page, setPage] = useState(0);

    function iOS() {
        return [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes(navigator.platform)
            // iPad on iOS 13 detection
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }

    useEffect(() => {
        if (!props.permissions) {
            setVisible(false);
            return;
        }

        if (iOS()) setVisible(true);
    }, [props.permissions]);

    const next = () => {
        if (page >= notifications.length - 1) return dismiss();
        setPage(page => page += 1);
    };

    const dismiss = () => {
        setVisible(false);
        setNotifications('initial');
        // props.onDismiss();
    };

    const share = async () => {
        const notification = notifications[page];
        if (!notification) return;

        const shareData = notification.shareData;
        if (!shareData) return;

        const shareLink = await api.links.add(shareData);
        publisher.publish('shareOptions', shareLink);
    };

    const notificationClass = conditional('PermissionModal', style, { visible });

    const cardsStyle = {
        width: 'calc(' + notifications.length + ' * 100%)',
        transform: 'translateX(-' + (100 / notifications.length) * page + '%)'
    };

    const card = notification => (
        <div className={style.card}>
            <div className={style.photo} style={{ backgroundImage: 'url(' + notification.photo + ')' }} />
            <h3 className={style.title}>{notification.title}</h3>
            <p className={style.description}>{notification.subtitle}</p>
            <div className={style.share} onClick={share}>
                <span className={'stat-text-c'}>Share This!</span>
            </div>
        </div>
    );

    return (
        <div className={notificationClass} onClick={dismiss}>
            <div className={style.container} onClick={e => e.stopPropagation()}>
                <div className={style.title}>Please Allow Access</div>
                <div className={style.description}>Make sure to give us access so we can give you credit!</div>
                <div className={style.instruction}>
                    <div className={style.instructionTitle}>Open your phone's settings and select</div>
                    <div className={style.instructionSteps}>
                        <div className={style.instructionStep}>Privacy</div>
                        <div className={style.instructionArrow} />
                        <div className={style.instructionStep}>Health</div>
                        <div className={style.instructionArrow} />
                        <div className={style.instructionStep}>AMP 2</div>
                        <div className={style.instructionArrow} />
                        <div className={style.instructionStep}>Turn On All</div>
                    </div>
                </div>
                {/* <div style={{ color: 'white' }}>{JSON.stringify(props.permissions)}</div> */}
                {/* <div style={{ color: 'white' }}>{JSON.stringify(w)}</div> */}
                <div className={style.buttonContainer}>
                    {/* <div className={style.done} onClick={next}>{page === notifications.length - 1 ? 'Finish' : 'Next'}</div> */}
                </div>
            </div>
        </div>
    );



};

export default PermissionModal;
